module.exports = {"name":"Type Name","tag":{"id":"0","text":"noTag"},"tagBit":{"id":"99","text":"noBit"},"tagScale":"1","tagOffset":"0","tagDecimals":"0"}


//////////////////
// WEBPACK FOOTER
// ./src/views/site/Developer/DeveloperOverviewRender/Components/Data/DataTypesInt.json
// module id = 351
// module chunks = 0